/** Tab-lifetime gates for demo claim — no session imports (avoids cycles). */

const claimStartedJobs = new Set<string>();
const inFlightClaim = new Map<string, Promise<unknown>>();

export function resetDemoClaimGate(jobId?: string): void {
  if (jobId) {
    claimStartedJobs.delete(jobId);
    inFlightClaim.delete(jobId);
    return;
  }
  claimStartedJobs.clear();
  inFlightClaim.clear();
}

export function markDemoClaimStarted(jobId: string): boolean {
  if (claimStartedJobs.has(jobId)) return false;
  claimStartedJobs.add(jobId);
  return true;
}

export function unmarkDemoClaimStarted(jobId: string): void {
  claimStartedJobs.delete(jobId);
}

export function getDemoClaimInFlight<T>(jobId: string): Promise<T> | undefined {
  return inFlightClaim.get(jobId) as Promise<T> | undefined;
}

export function setDemoClaimInFlight<T>(jobId: string, promise: Promise<T>): void {
  inFlightClaim.set(jobId, promise);
}

export function clearDemoClaimInFlight(jobId: string): void {
  inFlightClaim.delete(jobId);
}

export function hasDemoClaimStarted(jobId: string): boolean {
  return claimStartedJobs.has(jobId);
}
